// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper-module__wrapper___GNals","loading":"Wrapper-module__loading___6c3vg"};